<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App',
    components: {
    },

    // <!-- from Ads engine for production -->
    // mounted() {
    //   let adsConstantScript = document.createElement("script");
    //   adsConstantScript.setAttribute('type', 'text/javascript');
    //   adsConstantScript.innerHTML = 
    //     'const PUBLISHER_CODE = ' +
    //       '"fQRgDwb7sHwyhepvOilzKXo5Iyx874NZY0Isbsn3dq1YuY1Fz6KQEhUc1oqShWbQQV0iMftl30hBRL74tAvyYzmQkwuIYKBEgzlj4zqKBjMwkAsK3Di3KkBJz0ENj3emEmYrvJcZFc2S39ugkkU2HYkzxvHFazYZCDHOTkzwrKTyK3VGBwa6qEuV8RYanX8oG4jVxCgbRJVXzYycdP2tu4utYY2SxUdird7ybUtFbsXhFe8DTbICzx6ddVUlj6b";';
    //   document.head.appendChild(adsConstantScript);

    //   let adsScript = document.createElement("script");
    //   adsScript.setAttribute(
    //     "src",
    //     "https://bib-adsengine.com/static/js/cdn.js"
    //   );
    //   document.head.appendChild(adsScript);
    // }
    // <!-- from Ads engine for production -->

    // <!-- from Ads engine for staging -->
    mounted() {
      // let adsConstantScript = document.createElement("script");
      // adsConstantScript.setAttribute('type', 'text/javascript');
      // adsConstantScript.innerHTML = 
      //   'const PUBLISHER_CODE = ' +
      //     '"RBB9bcVvZL3FwJ4qnrdpK3gf2vMrYXmYelUpyIje8n9ny2u5yUUqgHHZyt5RMq8MlgKg3isTrvTykkxfieqQ50ZrF1iOc19k3xmN7oEifSCKw7KcwzljmmstIVVPVsmWul8kSTqlfRGRdEZWFRn1Y0FsEmgML9mu38zlTllwhpEYqBfgCmwR8YUPuY5rASvXCsFJCAsQ8Aq9wmLGqOwuhff9wvdr5htENBlxBhKuhk4cRjtUyYMl5mnmgRDWwtE";';
      // document.head.appendChild(adsConstantScript);

      // let adsScript = document.createElement("script");
      // adsScript.setAttribute(
      //   "src",
      //   "https://bib-adsengine-stg.com/static/js/ads_cdn.js"
      // );
      // document.head.appendChild(adsScript);
    }
    // <!-- from Ads engine for staging -->
  }
</script>

<style>
@import './assets/css/bootstrap.min.css';
@import './assets/css/style.css';
@import './assets/css/fontawesome-free/css/all.min.css';
/* @import 'https://bib-adsengine.com/static/css/cdn.css'; */
/* @import 'https://bib-adsengine-stg.com/static/css/ads_cdn.css'; */
</style>
